/* eslint-disable no-unused-vars */
import Vue from "vue";

export default {
	state: {
		documentRequirement: {},
		documentRequirementResponse: {},
		inviteDocument: {}
	},
	mutations: {
		setDocumentRequirementOnState(state, documentRequirement) {
			state.documentRequirement = documentRequirement;
		},
		setDocumentRequirementResponseOnState(state, documentRequirementResponse) {
			state.documentRequirementResponse = documentRequirementResponse;
		},
		setInviteDocumentOnState(state, inviteDocument) {
			state.inviteDocument = inviteDocument;
		}
	},
	actions: {
		uploadDocumentScore(_, data) {
			let formData = new FormData();
			formData.append("file", data.file);
			formData.append("idClient", data.idClient);
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.post("document/score", formData)
					.then((response) => {
						resolve(response.data.data);
					})
					.catch((error) => {
						reject(error);
					});
			});
		},
		uploadDocumentRequirement({ commit }, data) {
			let formData = new FormData();
			formData.append("file", data.file);
			formData.append("idClient", data.idClient);
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.post("document/requirement", formData)
					.then((response) => {
						commit("setDocumentRequirementOnState", response.data.data);
						resolve(response.data.data);
					})
					.catch((error) => {
						reject(error);
					});
			});
		},
		uploadInviteDocument({ commit }, data) {
			let formData = new FormData();
			formData.append("file", data.file);
			formData.append("idClient", data.idClient);
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.post("document/invite", formData)
					.then((response) => {
						commit("setInviteDocumentOnState", response.data.data);
						resolve(response.data.data);
					})
					.catch((error) => {
						reject(error);
					});
			});
		},
		getDocumentRequirement({ commit }, id) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("document/requirement/" + id)
					.then((response) => {
						this.state.loading = false;
						commit("setDocumentRequirementOnState", response.data.data);
						resolve(response.data.data);
					})
					.catch((error) => {
						this.state.loading = false;
						reject(error);
					});
			});
		},
		getDocumentRequirementResponse({ commit }, id) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("document/requirementResponse/" + id)
					.then((response) => {
						this.state.loading = false;
						commit("setDocumentRequirementResponseOnState", response.data.data);
						resolve(response.data.data);
					})
					.catch((error) => {
						this.state.loading = false;
						reject(error);
					});
			});
		},
		uploadFileRequirementResponse({ commit }, data) {
			return new Promise(async (resolve, reject) => {
				try {
					for (const fl of data.attach) {
						if (!fl.idInvite) {
							let formData = new FormData();
							formData.append("file", fl.file);
							const response = await Vue.prototype.$http.post(
								"document/requirementResponse/" + data.idRequirement + "/" + data.idInvite + "/" + fl.responseIndex,
								formData
							);
							commit("setDocumentRequirementResponseOnState", response.data.data);
						}
					}
					resolve();
				} catch (error) {
					reject(error);
				}
			});
		},
		getRequirementAttaches(_, { idRequirement, idInvite, responseIndex }) {
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get(`document/requirementResponseDocument/${idRequirement}/${idInvite}/${responseIndex}`)
					.then((response) => {
						resolve(response.data.data);
					})
					.catch((error) => {
						reject(error);
					});
			});
		},
		downloadRequirementDocument(_, fileId) {
			this.state.loading = true;
			Vue.prototype.$http.download(`document/requirementStream/${fileId}`).then((response) => {
				this.state.loading = false;
				browserDownload(response.headers["content-disposition"], response.data);
			});
		},
		downloadRequirementListDocumentByIdEntity(_, { id, idRequirementList, entityType, clientId }) {
			this.state.loading = true;
			Vue.prototype.$http
				.postDownload(`document/requirementStream/`, { id, idRequirementList, entityType, clientId })
				.then((response) => {
					this.state.loading = false;
					browserDownload(response.headers["content-disposition"], response.data);
				})
				.catch((error) => {
					this.state.loading = false;
					reject(error);
				});
		},
		downloadAllRequirementDocumentByIdAndIdRequirement(_, { id, idRequirement, entityType }) {
			this.state.loading = true;
			Vue.prototype.$http
				.download(`document/requirementStream/requirement/${id}/${idRequirement}/${entityType}`)
				.then((response) => {
					this.state.loading = false;
					browserDownload(response.headers["content-disposition"], response.data);
				})
				.catch((error) => {
					this.state.loading = false;
					reject(error);
				});
		},
		downloadRequirementResponseDocument(_, idDocument) {
			Vue.prototype.$http.download(`document/responseStream/${idDocument}`).then((response) => {
				this.state.loading = false;
				browserDownload(response.headers["content-disposition"], response.data);
			});
		},
		downloadRequirementResponseIndexDocument(_, idDocumentList) {
			return Vue.prototype.$http
				.postDownload("document/requirementQuestionStream/", idDocumentList)
				.then((response) => {
					browserDownload(response.headers["content-disposition"], response.data);
				})
				.catch((error) => {
					console.error(error);
				});
		},
		downloadReleaseDocument(_, filename) {
			this.state.loading = true;
			Vue.prototype.$http.download(`document/releaseStream/${filename}`).then((response) => {
				this.state.loading = false;

				var fileURL = window.URL.createObjectURL(new Blob([response.data]));
				let contentDisposition = response.headers["content-disposition"];
				let start = contentDisposition.indexOf("filename=") + 9;
				let end = contentDisposition.indexOf(";", start);
				var fileName = contentDisposition.substring(start, end).replaceAll('"', "");

				var fURL = document.createElement("a");

				fURL.href = fileURL;

				fURL.setAttribute("download", fileName);
				document.body.appendChild(fURL);

				fURL.click();
			});
		},
		getInviteDocument({ commit }, id) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("document/invite/" + id)
					.then((response) => {
						commit("setInviteDocumentOnState", response.data.data);
						resolve(response.data.data);
					})
					.catch((error) => {
						console.error(error);
						reject(error);
					})
					.finally(() => {
						this.state.loading = false;
					});
			});
		},
		downloadInviteDocument(_, fileId) {
			this.state.loading = true;
			Vue.prototype.$http.download(`document/inviteStream/${fileId}`).then((response) => {
				this.state.loading = false;

				var fileURL = window.URL.createObjectURL(new Blob([response.data]));
				let contentDisposition = response.headers["content-disposition"];
				let start = contentDisposition.indexOf("filename=") + 9;
				let end = contentDisposition.indexOf(";", start);
				var fileName = contentDisposition.substring(start, end).replaceAll('"', "");

				var fURL = document.createElement("a");

				fURL.href = fileURL;

				fURL.setAttribute("download", fileName);
				document.body.appendChild(fURL);

				fURL.click();
			});
		},
		downloadAllOfferDocuments(_, idOffer) {
			this.state.loading = true;
			Vue.prototype.$http
				.download(`document/allOfferDocumentStream/${idOffer}`)
				.then((response) => {
					this.state.loading = false;
					browserDownload(response.headers["content-disposition"], response.data);
				})
				.catch((error) => {
					this.state.loading = false;
					reject(error);
				});
		},
		downloadOfferDocument(_, idDocument) {
			this.state.loading = true;
			Vue.prototype.$http
				.download(`document/offerDocumentStream/${idDocument}`)
				.then((response) => {
					this.state.loading = false;
					browserDownload(response.headers["content-disposition"], response.data);
				})
				.catch((error) => {
					this.state.loading = false;
					reject(error);
				});
		}
	},
	getters: {
		documentRequirement(state) {
			return state.documentRequirement;
		},
		documentRequirementResponse(state) {
			return state.documentRequirementResponse;
		},
		inviteDocument(state) {
			return state.inviteDocument;
		}
	}
};

const browserDownload = function (contentDisposition, blobData) {
	var fileURL = window.URL.createObjectURL(new Blob([blobData]));
	let start = contentDisposition.indexOf("filename=") + 9;
	let end = contentDisposition.indexOf(";", start);
	var fileName = contentDisposition.substring(start, end).replaceAll('"', "");

	var fURL = document.createElement("a");

	fURL.href = fileURL;

	fURL.setAttribute("download", fileName);
	document.body.appendChild(fURL);

	fURL.click();
};
